import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {GetRoomFilter, RoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getRoomsService(dto: GetRoomFilter) {
  return axios.post<ResponseObjectPaginated<RoomModel[]>>(`${BASEURL}/room/getList`, dto)
}

export function getListRoomsExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/room/getListExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getTemplateRoomService() {
  return axios.post<any>(
    `${BASEURL}/room/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
